var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-top-5xl padding-bottom-2xl",
      attrs: { id: "pro-plus" },
    },
    [
      _c("div", { staticClass: "row margin-bottom-4xl" }, [
        _c("div", { staticClass: "column-12 text-center" }, [
          _c(
            "h2",
            {
              staticClass: "text-uppercase size-md with-anchor",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
                color: "var(--fa-dk-teal)",
              },
            },
            [
              _c("anchor-link", {
                attrs: {
                  anchor: "#pro-plus",
                  "link-color": "teal",
                  "anchor-name": "New Icon Packs",
                },
              }),
              _vm._v("\n        Hot Off the Griddle\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "line-length-xl margin-auto" },
            [
              _vm._v(
                '\n        Entirely new, visually unique "small batch" icon packs designed in collaboration with world-class icon designers.\n        '
              ),
              _c(
                "site-link",
                {
                  attrs: { to: { name: "plans", query: { plans: "plus" } } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("upgrade_link_click", {
                        context: "home_view",
                      })
                    },
                  },
                },
                [_vm._v("Available now in all Pro+ plans")]
              ),
              _vm._v("!\n      "),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column-12" },
          [
            _c(
              "div",
              {
                staticClass:
                  "message teal align-middle display-flex margin-bottom-2xl",
                staticStyle: { "--message-border-width": "0" },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "decorative",
                  attrs: { icon: _vm.$v7.solid.faShapes, size: "2xl" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "tablet:display-flex align-between align-middle",
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    !_vm.isActiveProPlus
                      ? _c(
                          "site-link",
                          {
                            staticClass:
                              "button teal margin-top-xl margin-bottom-2xs tablet:margin-top-0",
                            staticStyle: { "flex-shrink": "0" },
                            attrs: { to: { name: "plans" } },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "margin-right-2xs",
                              attrs: { icon: _vm.$v7.solid.faTag, size: "xl" },
                            }),
                            _vm._v("\n            Upgrade to Pro+\n          "),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("icon-pack-cards", {
              staticStyle: {
                "--card-margin-bottom": "0",
                gap: "var(--spacing-2xl) 0",
              },
              attrs: {
                "collection-name": "pro-plus-exclusive-collection",
                "more-soon": "",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h2 margin-y-md" }, [
      _vm._v("\n        New Icon Packs\n        "),
      _c(
        "span",
        {
          staticClass: "tag teal margin-left-xs size-2xs",
          staticStyle: {
            "--tag-border-radius": "var(--border-radius-sm)",
            "--tag-padding":
              "var(--spacing-3xs) var(--spacing-2xs) var(--spacing-2xs) var(--spacing-sm)",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "var(--font-size-xs)",
                "font-weight": "var(--font-weight-black)",
                "letter-spacing": "var(--letter-spacing-3xl)",
              },
            },
            [_vm._v("Pro+")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "margin-bottom-0 margin-x-2xl" }, [
      _vm._v(
        "\n            Each Pro+ icon pack contains a curated selection of the "
      ),
      _c("strong", [_vm._v("200 most common icons")]),
      _vm._v(" needed for app and website design.\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }